import { action, makeObservable, observable } from 'mobx'
import { ProductCardModel } from '../server/mpsklad_core/Models/MpCard/ProductCardModel'

export class MpCardStore {
  @observable
  selectedRows: object[] = []

  @observable
  selectedProductCards: ProductCardModel[] = []

  constructor() {
    makeObservable(this)
  }

  get selectedCount() {
    return this.selectedRows.length
  }

  get rows() {
    return this.selectedRows
  }

  @action
  addRow = (row: object) => {
    this.selectedRows.push(row)
  }

  @action
  deleteRow = (row: object) => {
    this.selectedRows = this.selectedRows.filter(r => r !== row)
  }

  @action
  setSelectedProductCards = (cards: ProductCardModel[]) => {
    this.selectedProductCards = cards
  }

  @action
  addProductCard = (card: ProductCardModel) => {
    this.selectedProductCards.push(card)
  }

  @action
  clearSelectedRows = () => {
    this.selectedRows = []
  }

  @action
  clearSelectedProductCards = () => {
    this.selectedProductCards = []
  }
}